import { DropdownItemProps, DropdownProps } from 'semantic-ui-react'
import { FormatNumberOptions } from 'react-intl'
import isEmpty from 'lodash.isempty'
import isNil from 'lodash.isnil'
import { ALL_UNDERSCORES, LESS_THAN_TWO_DECIMAL_PLACES, TWO_OR_MORE_DECIMAL_PLACES } from './regexConstants'

export interface FormDisplayData {
  raw: number | string | null
  display: string
  error?: boolean | string | null
}
export const numberInputFormatter = (
  value: string,
  formatNumber: (num: number, options?: FormatNumberOptions) => string,
  includeMinDecimalPlace?: boolean
) => {
  let fieldData: FormDisplayData = {
    raw: null,
    display: '',
  }

  // Remove any commas from the formatted number
  let amt = Number.parseFloat(value.replace(/,/g, ''))

  // Don't accept any other values except valid numbers and decimals
  if (!Number.isNaN(amt) || value === '.') {
    fieldData.raw = amt
    // if a decimal is the last character, don't format
    if (includeMinDecimalPlace) {
      fieldData.display = formatNumber(amt, {
        style: 'decimal' as 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    } else if (value.search(LESS_THAN_TWO_DECIMAL_PLACES) !== -1) {
      // if there is a decimal and less than 2 values
      fieldData.display = value
    } else if (value.search(TWO_OR_MORE_DECIMAL_PLACES) !== -1) {
      // if there are 2 or more decimal places, set the max fraction digits to 2
      fieldData.display = formatNumber(amt, {
        style: 'decimal' as 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    } else {
      fieldData.display = formatNumber(amt)
    }
  }
  return fieldData
}

export const parseOptionData = (data: DropdownProps) => {
  const selectedValue = data.value as string
  const selectedOption = data.options?.find((option: DropdownItemProps) => option.value === selectedValue)
  const fieldData: FormDisplayData = {
    raw: selectedValue,
    display: (selectedOption?.text as string) || selectedValue,
    error: null,
  }
  return fieldData
}

export const capitalizeWord = (word: string = '') => {
  if (isNil(word) || isEmpty(word)) {
    return ''
  }
  const firstLetter = word[0]?.toUpperCase()
  const restOfWord = word.substring(1).toLowerCase()
  return `${firstLetter}${restOfWord}`
}

export const removeUnderscores = (word: string = '') => {
  if (isNil(word)) {
    return ''
  }
  return word.replace(ALL_UNDERSCORES, ' ')
}

export const formatPhoneNumber = (phoneNumberString: string) => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)

  return match ? [match[1] ? '+1 ' : '', match[2], '-', match[3], '-', match[4]].join('') : phoneNumberString
}

export default numberInputFormatter
